import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const showSkillsAdvancersQuestionInOnboarding = () =>
  GrowthDiscoveryEpicClient.preview('enableOnboardingAdvancersHomeComplexCollection');
